import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ContentSection } from './components/ContentSection';
import { Footer } from './components/Footer';
import { WebinarDetailsSection } from './components/WebinarDetailsSection';
import { StickyMobileCTA } from './components/ui/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen w-full bg-[#FAFAF8] flex flex-col items-center" data-id="element-0">
      <Header data-id="element-1" />

      <main className="w-full max-w-[720px] px-4 md:px-6 lg:px-0" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ContentSection data-id="element-4" />
        <WebinarDetailsSection data-id="element-5" />
        <Footer data-id="element-6" />
      </main>

      <StickyMobileCTA data-id="element-7" />
    </div>;
}